function FavoriteLoader() {
  const observable = require('@riotjs/observable')
  observable(this)

  this.handler = (type, watchId) => {
    switch (type) {
      case 'add':
        return 'didAddToFavorite' + watchId
      case 'remove':
        return 'didRemoveFromFavorite' + watchId
      case 'fetch':
        return 'didFetchFavorite' + watchId
      case 'unauthorized':
        return 'shouldAuthorizeForAction' + watchId
      default:
        return
    }
  }

  this.addToFavorite = (watchId) => { _postFavorite('add_to_favorite', watchId) }
  this.removeFromFavorite = (watchId) => { _postFavorite('remove_from_favorite', watchId) }
  this.fetchFavorite = (watchId) => { _fetchFavorite(watchId) }
  this.fetchFavorites = (callback) => {
    let headers = new Headers()
    headers.append('Content-Type', 'text/json');
    this.authorized = document.cookie.split(';').filter((item) => item.trim().startsWith('_tkn_signedin=')).length > 0
    if (!this.authorized) return callback();

    let url = '/favorites/?format=json&tkn_signedin=' + document.cookie.split(';').filter((item) => item.trim().startsWith('_tkn_signedin='))[0].split("=")[1]
    fetch(url, {
      mode: 'same-origin',
      headers: headers
    }).then( (res) => res.json()).then( (res) => {
      this.cachedIds = res.ids;
      callback()
    }).catch( (err) => {
      console.error(err)
      this.authorized = false;
      callback()
    })
  }

  let _fetchFavorite = (watchId) => {
    if (this.authorized) {
      if (!this.cachedIds) return
      if (this.cachedIds.includes(Number(watchId))) {
        this.trigger(this.handler('add', watchId))
      } else {
        this.trigger(this.handler('remove', watchId))
      }
    } else {
      this.trigger(this.handler('unauthorized', watchId))
    }
  }

  let _postFavorite = (action, watchId) => {
    let headers = new Headers()
    if (__UDEDOKEI_ENV__ == 'staging') {
      headers.append('Authorization', __AUTH_KEY__);
    }
    headers.append('Content-Type', 'text/json');
    let url = '/affiliate_watches/' + watchId + '/' + action + '?tkn_signedin=' + document.cookie.split(';').filter((item) => item.trim().startsWith('_tkn_signedin='))[0].split("=")[1]

    fetch(url, {
      mode: 'same-origin',
      headers: headers
    }).then( (res) => res.json()).then( (res) => {
      // console.log(res)
      if (res.result == 'unauthorized') {
        this.trigger(this.handler('unauthorized', watchId))
      } else if (res.result == 'ok') {
        this.trigger(this.handler(res.action, watchId))
      }
    }).catch( (err) => {
      // console.log(err)
    })


  }
}

module.exports = FavoriteLoader
